/* global coreui */

/**
 * --------------------------------------------------------------------------
 * CoreUI PRO Boostrap Admin Template tooltips.js
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

for (const element of document.querySelectorAll('[data-coreui-toggle="tooltip"]')) {
  // eslint-disable-next-line no-new
  new coreui.Tooltip(element)
}
